"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doParse = exports.format = void 0;
const date_fns_1 = require("date-fns");
var date_fns_2 = require("date-fns");
Object.defineProperty(exports, "format", { enumerable: true, get: function () { return date_fns_2.format; } });
const doParse = (date, formats = ['yyyy-MM-dd', 'dd/MM/yyyy']) => {
    for (let i = 0; i < formats.length; i++) {
        try {
            const parsed = (0, date_fns_1.parse)(date, formats[i], new Date(0));
            if (!!date && (0, date_fns_1.isValid)(parsed))
                return parsed;
        }
        catch (e) {
            continue;
        }
    }
    return null;
};
exports.doParse = doParse;
